import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Board, Ticket, TicketsPositionRequest } from "../../backend/backendapi";
import { KanbanState } from "../kanban.model";
import KanbanFlow from "./kanbanflow";

@Component({
    name: 'KanbanBoard',
    components: { KanbanFlow }
})
export default class KanbanBoard extends Vue {
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    board!: Board;

    private drag: boolean = false;
    private newFlow: string | null = null;

    private dragOptions = {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
    };

    private get flows(): Ticket[] {
        return ([...(this.board.tickets ?? [])]).sort((l, r) => (l.positionNo ?? 0) - (r.positionNo ?? 0));
    }

    private set flows(flows: Ticket[]) {
        console.log(flows);
        this.board.tickets = flows; //keep ui in new state until update arrives

        this.state.ticketAPI.updatePosition(new TicketsPositionRequest({ boardId: this.board.id, tickets: flows }))
            .then(newflows => this.board.tickets = newflows.result!);
    }

    private get noVisibleFlows(): boolean {
        this.state.filter; //HACK: this a recompute trigger, this.$refs.kanbanFlow.visibleOnFilter depends on state.filter
        let flows = this.$refs.kanbanFlow as KanbanFlow[] ?? [];
        return flows.length > 0 && flows.every(e => !e.visibleOnFilter);
    }

    private createFlow(): void {
        if (!this.newFlow)
            return;

        let flow = new Ticket();
        flow.createdOn = new Date();
        flow.boardId = this.board.id;
        flow.name = this.newFlow;

        this.state.ticketAPI.create(flow)
            .then(newflow => {
                this.$toasted.info(this.$t('txtCreated').toString());
                if (!this.board.tickets)
                    this.board.tickets = [];
                this.board.tickets.push(newflow.result!);

                this.newFlow = null;
                this.$emit('flow-created', newflow.result!);
            })
            .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
    }
}
